module.exports = __webpack_public_path__ + "img/newAndold.a5d7ef1e.png";